import { render } from "./B2bTablePlannedProcesses.vue?vue&type=template&id=017af60f&scoped=true&lang=pug"
import script from "./B2bTablePlannedProcesses.vue?vue&type=script&lang=js"
export * from "./B2bTablePlannedProcesses.vue?vue&type=script&lang=js"

import "./B2bTablePlannedProcesses.vue?vue&type=style&index=0&id=017af60f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017af60f"]])

export default __exports__